import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { tryToInviteNewPartner } from '../../../../store/brokers/admin/partners/partnersSlice';
import Button from '../../../../shared/button';
import Modal from '../../../../shared/modal';
import Error from '../../../../shared/error';
import Input from '../../../../shared/input';


interface IInvitePartnerModal {
    openModal: boolean;
    handleCloseModal: () => void;
}

const InvitePartnerModal = ({
    openModal,
    handleCloseModal,
}: IInvitePartnerModal) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(false)
    const [email, setEmail] = useState<any>()
    const [firstName, setFirstName] = useState<string>();
    const [lastName, setLastName] = useState<string>();
    const [generalError, setGeneralError] = useState<string>()

    const onCloseModal = () => {
        handleCloseModal();
        setEmail(undefined);
    }

    const onSubmit = async () => {
        if(!email || !firstName || !lastName){
            setGeneralError('Please fill all the fields to continue')
            return;
        }
        setLoading(true)
        setGeneralError(undefined)
        try {
            const formData = {
                email: email,
                firstName: firstName,
                lastName: lastName
            }
            await dispatch(tryToInviteNewPartner(formData)).unwrap();
            onCloseModal()
        } catch (err) {
            setGeneralError('Something went wrong, please try again or contact our team')
        }
        setLoading(false)
    }

    const onChangeEmail = (e: any, type: string) => {
        setEmail(e)
    }

    const onChangeFirstName = (e: any, type: string) => {
        setFirstName(e)
    }

    const onChangeLastName = (e: any, type: string) => {
        setLastName(e)
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[400px]'}>
                <p className='mb-4 font-semibold text-sm'>Invite Partner</p>
                {generalError && <Error text={generalError} />}
                <div className='min-w-[95%] my-5'>
                    <Input
                        label='First Name'
                        placeholder=' '
                        containerStyle='mb-1'
                        showValue={true}
                        inputValue={firstName}
                        onChangeInput={onChangeFirstName}
                    />
                    <Input
                        label='Last Name'
                        placeholder=' '
                        containerStyle='mb-1'
                        showValue={true}
                        inputValue={lastName}
                        onChangeInput={onChangeLastName}
                    />
                    <Input
                        label='Email'
                        placeholder=' '
                        containerStyle='mb-1'
                        showValue={true}
                        inputValue={email}
                        onChangeInput={onChangeEmail}
                    />
                </div>
                <div className='min-w-[100%] flex flex-row justify-center my-4'>
                    <Button
                        label={'Invite Partner'}
                        className={loading ? 'btn-primary-rounded-less-disable my-5 min-w-[150px] !shadow-none' : 'btn-primary-rounded-less my-5 min-w-[150px] !shadow-none'}
                        type='submit'
                        onClickButton={onSubmit}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default InvitePartnerModal;